// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { OverflowTypography } from '@/components/overflow-typography';
import { TypographyProps } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = Omit<
  TypographyProps,
  'overflow' | 'whiteSpace' | 'textOverflow' | 'maxWidth'
> & {
  maximumWidth: string | number;
};

export function EllipsisTypography(props: PropsWithChildren<Props>) {
  const { maximumWidth, ...typographyProps } = props;

  return (
    <OverflowTypography
      {...typographyProps}
      overflow="hidden"
      whiteSpace="nowrap"
      textOverflow="ellipsis"
      maxWidth={maximumWidth}
    >
      {props.children}
    </OverflowTypography>
  );
}
